import { defineComponent as _defineComponent } from 'vue'
import { useModalInstance } from '@/composables/useModalInstance';
import ClientBadge from '@/components/badges/ClientBadge.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendOffersConfirmModal',
  setup(__props) {

const modal = useModalInstance();

return { __sfc: true,modal, ClientBadge }
}

})